import { type ComponentProps, type FC } from "react";
import { Button } from "@root/shared/components/Button";
import { AcceptScoutLink } from "@userFrontend/components/Links/AcceptScoutLink";
import { EntryLink } from "@userFrontend/components/Links/EntryLink";
import { type ModalLinkParams } from "@userFrontend/features/publication/components/WorkWithShopWorkCassette/type";

type Props = {
  size?: ComponentProps<typeof Button>["size"];
  enterableFlag: boolean;
  entriedFlag: boolean;
  scoutedFlag: boolean;
  // スカウトを受けるボタン用
  scoutedEntryUrl: string;
  workCode: string;
  scoutGaAction: string;
  scoutGaLabel: string;
  // 応募ボタン用
  query: string;
  entryUrl: string;
  entryGaAction: string;
  entryGaLabel: string;
  handleClickLink: (params: ModalLinkParams) => void;
};

export const EntryOrScoutButton: FC<Props> = ({
  size,
  enterableFlag,
  entriedFlag,
  scoutedFlag,
  scoutedEntryUrl,
  workCode,
  scoutGaAction,
  scoutGaLabel,
  query,
  entryUrl,
  entryGaAction,
  entryGaLabel,
  handleClickLink,
}) => {
  if (entriedFlag) {
    return (
      <Button theme="disabled" size={size}>
        応募済み
      </Button>
    );
  }
  if (scoutedFlag) {
    return (
      <AcceptScoutLink
        text="スカウトを受ける"
        url={scoutedEntryUrl}
        size={size}
        workCode={workCode}
        gaAction={scoutGaAction}
        gaLabel={scoutGaLabel}
        onClick={(e) =>
          handleClickLink({
            url: scoutedEntryUrl,
            query,
            event: e,
            gaAction: scoutGaAction,
            gaLabel: scoutGaLabel,
          })
        }
        data-ga-action={scoutGaAction}
        data-ga-label={scoutGaLabel}
      />
    );
  }
  if (enterableFlag) {
    return (
      <EntryLink
        text="応募画面へ進む"
        url={entryUrl}
        query={query}
        size={size}
        gaAction={entryGaAction}
        gaLabel={entryGaLabel}
        onClick={(e) =>
          handleClickLink({
            url: entryUrl,
            query,
            event: e,
            gaAction: entryGaAction,
            gaLabel: entryGaLabel,
          })
        }
        data-ga-action={entryGaAction}
        data-ga-label={entryGaLabel}
      />
    );
  }
  return (
    <Button theme="disabled" size={size}>
      募集停止
    </Button>
  );
};
